import OperationsPageShell from '../components/OperationsPageShell';

const eodKpis = [
  { label: 'New orders', value: 138 },
  { label: 'Processed today', value: 120 },
  { label: 'Overdue', value: 12 },
  { label: 'Vehicles available', value: 19 },
];

const EndOfDay = () => (
  <OperationsPageShell
    title="End of Day"
    subtitle="Daily KPI snapshot, comparison deltas, and export-ready operational summary."
    action={
      <>
        <button type="button" className="uw-btn uw-btn-light uw-btn-sm btn btn-sm btn-light">
          Today
        </button>
        <button type="button" className="uw-btn uw-btn-primary uw-btn-sm btn btn-sm btn-primary ms-2">
          Download Excel
        </button>
      </>
    }
  >
    <div className="row g-5 mb-5">
      {eodKpis.map((kpi) => (
        <div key={kpi.label} className="col-md-3 col-sm-6">
          <div className="card border h-100">
            <div className="card-body">
              <div className="text-muted small">{kpi.label}</div>
              <div className="fs-3 fw-bold mt-2">{kpi.value}</div>
              <div className="text-success small mt-2">+6.1% vs previous day</div>
            </div>
          </div>
        </div>
      ))}
    </div>

    <div className="card border">
      <div className="card-header border-0">
        <h5 className="mb-0">Rental vs Company split</h5>
      </div>
      <div className="card-body">
        <div className="text-muted">Not available</div>
      </div>
    </div>
  </OperationsPageShell>
);

export default EndOfDay;
